import { useEnvBadgeConfig } from '../../../hooks/useEnvBadgeConfig';

export const EnvironmentBadge = () => {
  const { data, isLoading, isError } = useEnvBadgeConfig();

  if (isLoading || isError || !data?.show) {
    return null;
  }

  return (
    <div className="fixed top-0 left-1/2 z-[9999] -translate-x-1/2">
      <div className="flex rounded-b-lg bg-icon-dark px-5 py-0.5 shadow-tiny">
        <span className="text-s11-sb text-text-primary-inverse uppercase">
          {data.clientName} - {data.envName}
        </span>
      </div>
    </div>
  );
};
